import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cwk_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Single-flight redirect — prevents 6+ 401 errors from flashing the UI.
let redirecting = false;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      // Public endpoints can also 401; only treat as session-expired if a token was sent.
      const hadToken = !!err?.config?.headers?.Authorization;
      const onAuthPage = window.location.pathname.startsWith("/login") || window.location.pathname.startsWith("/register");
      if (hadToken && !onAuthPage) {
        localStorage.removeItem("cwk_token");
        localStorage.removeItem("cwk_user");
        if (!redirecting) {
          redirecting = true;
          // Allow current React render cycle to settle, then redirect.
          setTimeout(() => {
            const from = encodeURIComponent(window.location.pathname + window.location.search);
            window.location.replace(`/login?session_expired=1&from=${from}`);
          }, 50);
        }
        // Return an empty success response so no Uncaught error bubbles up in dev overlay.
        return Promise.resolve({ data: null, status: 401, statusText: "Unauthorized", headers: {}, config: err.config });
      }
    }
    return Promise.reject(err);
  }
);

export default api;
